export const selectDomainCreate = ({ domain: { create } }) => create;
export const selectDomainGet = ({ domain: { get } }) => get;
export const selectDomainRemove = ({ domain: { remove } }) => remove;
